import { useMemo } from 'react';
import styles from './ProductAttribute.module.scss?module';
import { ProductAttributeInterface } from '../../../Interface/ProductAttribute';
import { Col, Row } from 'react-bootstrap';
import ProductAttributeName from './ProductAttributeName/ProductAttributeName';
import Availability from './Availability/Availability';
import NutritionFacts from './NutritionFacts/NutritionFacts';
import QuantityOrNotify from './QuantityOrNotify/QuantityOrNotify';
import { ProductSizeInterface } from '../../../Interface/ProductSize';
import { useAtom } from 'jotai';
import { selectedFlavorFamily } from '../../Atoms/ProductAtoms';
import { useUser } from '../../Context/UserContext';
import { getProductSizeDiscountDisplay } from '../../Helper/flavourDiscount';

export default function ProductAttribute({
  product_attribute,
  product_size,
  allowBackorder = false,
}: {
  product_attribute: ProductAttributeInterface;
  product_size?: ProductSizeInterface;
  allowBackorder?: boolean;
}) {
  const { user } = useUser();

  // Ob pro Flavour die (kombinierte) Clearance-Info inkl. Preis erscheint,
  // entscheidet zentral getProductSizeDiscountDisplay: bei Promotion oder
  // unterschiedlichen Clearance-Rabatten ja; bei einheitlichem Clearance-Rabatt
  // steht der Prozentwert nur im PID-Störer, unter dem Flavour nur der Grund.
  const showFlavourDiscount = useMemo(
    () =>
      product_size
        ? getProductSizeDiscountDisplay(product_size).showFlavourDiscount
        : false,
    [product_size]
  );

  const [selectedFlavor, setSelectedFlavor] = useAtom(
    selectedFlavorFamily(product_size?.id)
  );

  const onClick = () => {
    setSelectedFlavor({
      id: product_attribute.id,
      flavorImages: {
        front_image_url: product_attribute.image_white_public_url,
        sell_sheets: [],
      },
    });
  };

  return (
    <div
      role="button"
      onClick={onClick}
      style={{
        backgroundColor:
          selectedFlavor.id == product_attribute.id ? '#c6c8cc' : undefined,
      }}
      className={['w-100 my-1', styles.productAttribute].join(' ')}
    >
      <Row className={`g-0 ${!user ? 'justify-content-between' : ''}`}>
        {user && !allowBackorder ? (
          <Col
            xs={1}
            md={2}
            xxl={3}
            className="d-none d-md-block order-md-2 ps-2 ps-md-0"
          >
            {' '}
            <Availability product_attribute={product_attribute} />{' '}
          </Col>
        ) : null}

        <Col
          xs={7}
          md={5}
          className={`order-md-1 p-2 d-flex justify-content-center flex-column`}
        >
          <ProductAttributeName
            isUserLoggedIn={!!user}
            product_attribute={product_attribute}
            showDiscountDetails={showFlavourDiscount}
          />
        </Col>
        {product_attribute?.nutrition_facts?.length > 0 ? (
          <Col className="order-3" xs={1} md={2}>
            <NutritionFacts
              className="align-items-center justify-content-end p-2"
              product_attribute={product_attribute}
            />
          </Col>
        ) : null}

        {user ? (
          <Col xs={4} md={3} xxl={2} className={`order-4 p-0 d-flex ms-auto`}>
            <QuantityOrNotify
              className={styles.qtyInput}
              product_attribute={product_attribute}
              price={product_size?.price ?? 0}
              combined_price={product_attribute.combined_price}
              allowBackorder={allowBackorder}
            />
          </Col>
        ) : null}
      </Row>
    </div>
  );
}
